import type APIResponseData from "~/types/APIResponseData";
import type Schema from "~/types/Schema";
import type SchemaChild from "~/types/SchemaChild";
import type SchemaParent from "~/types/SchemaParent";
import type DataType from "~/types/DataType";
import { DATATYPES } from "~/constants/dataTypes";
import useLowerCamelCase from "~/utils/useLowerCamelCase";

function getCamelCaseName(item: APIResponseData<Schema | DataType> | SchemaChild | SchemaParent) {
  const useLowerCamelName = useLowerCamelCase(item);
  return (
    item.fieldData?.camelCaseName ??
    (item.childLowerCamelName && useLowerCamelName ? item.childLowerCamelName : item.childCamelCaseName) ??
    (item.parentLowerCamelName && useLowerCamelName ? item.parentLowerCamelName : item.parentCamelCaseName) ??
    (item.fieldData?.datatypeId ? item.fieldData?.name : "")
  );
}
function schemaLink(item: APIResponseData<Schema | DataType> | SchemaChild | SchemaParent) {
  const path =
    item.fieldData?.dataType ??
    item.childDataType ??
    item.parentDataType ??
    (item.fieldData?.datatypeId ? "dataType" : "");
  const camelCaseName = getCamelCaseName(item);

  if (path && DATATYPES[path.toLowerCase()]) {
    return `/${path.toLowerCase()}/${encodeURIComponent(camelCaseName)}`;
  }

  // If no path found, default it to property since property is others then datatype_id =  1 or 21
  return `/property/${encodeURIComponent(camelCaseName)}`;
}

export default schemaLink;
